import { render, staticRenderFns } from "./FirstTab.vue?vue&type=template&id=398f78d8&scoped=true"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"
import style0 from "./FirstTab.vue?vue&type=style&index=0&id=398f78d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f78d8",
  null
  
)

export default component.exports